// extracted by mini-css-extract-plugin
export var artworkWrapperStyle = "section_stats-module--artworkWrapperStyle--KcgbK";